import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';

import './Uploaded Documents.css';
import { handleDownload } from '../../common/Utilities';
import { DownloadDocumentFile, IMAGE_BASE_URL } from '../../common/Constants';

const UploadedDocuments = ({ documents }) => {
  const [visible, setVisible] = useState(false);
  const [fileDocumentType, setFileDocumentType] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');


  const fileType = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Image');
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Document');
      }
    }
  };

  const GetFileType = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        return 'img';
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        return 'doc';
      }
    }
  };

  return (
    <section className='document-list-section'>
      <div className='document-list-group'>
        <h3 className='text-[13px] font-[500] text-[#0D062D]'>
          {documents?.label}
        </h3>
        {documents?.files?.map((document, i) => (
          <div
            className='document-list'
            key={i}
            onClick={() => {
              fileType(document.path);
              setPreviewUrl(`${IMAGE_BASE_URL}${document.path}`);
              setVisible(true);
              setPreviewTitle(
                document.name ||
                document.path.substring(document.path.lastIndexOf('/') + 1)
              );
            }}
          >
            {GetFileType(document?.path) === 'doc' ? (
              <span className='file-icon'>
                <FilePdfOutlined className='pdfOutlineStyle' />
              </span>
            ) : (
              <span className='file-icon'>
                <img
                  className='prev-img'
                  src={`${IMAGE_BASE_URL}${document.path}`}
                  alt='document'
                />
              </span>
            )}
            <span className='file-name'>
              <p>{document.name}</p>
            </span>
            <Button
              type='link'
              onClick={() => DownloadDocumentFile(document.path)}
            >
              <img
                src='/images/document_download.png'
                alt='Download Document'
                className='max-w-xs'
              />
            </Button>

          </div>
        ))}
      </div>
      <Modal
        open={visible}
        title={previewTitle}
        centered
        onOk={() => {
          handleDownload(`${previewUrl}`);
        }}
        onCancel={() => setVisible(false)}
        okText={'Download'}
        cancelText={'Close'}
        width={700}
        footer={
          <div className='flex justify-between'>
            <div className='w-full'>
              <Button key='back' onClick={() => setVisible(false)}>
                Close
              </Button>
              <Button
                key='download'
                type='primary'
                onClick={() => {
                  handleDownload(`${previewUrl}`);
                }}
              >
                Download
              </Button>
            </div>
          </div>
        }
      >
        {fileDocumentType === 'Image' ? (
          <img
            alt='example'
            style={{
              width: '100%',
            }}
            src={previewUrl}
          />
        ) : (
          <iframe src={previewUrl} className='w-full' height={400} />
        )}
      </Modal>
    </section>
  );
};

export default UploadedDocuments;
